export default __webpack_public_path__ + "images/ni-d30c03773b8ce54120334c712f6c79f9.svg";